import '../style/slider-CTm0V6Fa.css'
import { defineComponent as O, useCssVars as j, toRef as H, useModel as T, ref as m, computed as l, useSlots as W, watch as q, openBlock as G, createBlock as J, unref as i, normalizeClass as g, normalizeStyle as y, withCtx as c, createVNode as K, renderSlot as P, createElementVNode as Q } from "vue";
import U from "vue-slider-component";
import { useInputSize as X } from "./hooks/useInputSize.js";
import Y from "./popper.js";
import { useFormItem as Z } from "./hooks/useFormItem.js";
const oe = /* @__PURE__ */ O({
  name: "e-slider",
  __name: "slider",
  props: {
    modelValue: { default: 0 },
    data: {},
    dataValue: { default: "value" },
    dataLabel: { default: "label" },
    lazy: { type: Boolean },
    disabled: { type: Boolean },
    min: { default: 0 },
    max: { default: 1 },
    marks: { type: [Boolean, Object, Array, Function] },
    interval: { default: 0.01 },
    hideLabel: { type: Boolean },
    railStyle: {},
    processStyle: { default: () => ({
      backgroundColor: "var(--bg-status-primary-bold)"
    }) },
    process: { type: [Boolean, Function], default: !0 },
    overflow: { type: Boolean },
    size: {}
  },
  emits: ["drag-start", "dragging", "drag-end"],
  setup(h, { emit: S }) {
    j((e) => ({
      33913509: I.value
    }));
    const t = h, d = S, { formItem: b, formSize: w } = Z(), { isSmallSize: f } = X({ formSize: w, propSize: H(t, "size") }), r = T(t, "modelValue"), s = m(0), u = m(!1), o = m(!1), z = {
      width: "8px",
      height: "8px",
      top: "-2px",
      backgroundColor: "var(--bg-surface-1)",
      border: "2px solid var(--bg-status-plain)",
      boxShadow: "none",
      cursor: "pointer"
    }, x = {
      backgroundColor: "var(--bg-status-primary-bold)",
      border: "none"
    }, k = {
      color: "var(--text-secondary)",
      fontWeight: 500,
      fontSize: "12px",
      lineHeight: "16px"
    }, C = l(() => ({
      backgroundColor: "var(--bg-status-plain)",
      borderRadius: "var(--border-radius-lg)",
      height: f.value ? "2px" : "4px",
      ...t.railStyle
    })), $ = l(() => [
      "e-slider",
      {
        "e-slider--hover": o.value
      }
    ]), n = l(() => f.value ? 16 : 24), V = l(() => {
      const e = n.value, a = `${e}px`, p = `${e}px`;
      return {
        width: a,
        height: p,
        backgroundColor: "var(--common-white)",
        borderColor: "var(--border-surface) !important",
        boxShadow: "var(--box-shadow-lg)"
      };
    }), B = l(() => [
      "vue-slider-dot-handle",
      {
        "vue-slider-dot-handle-disabled": t.disabled
      }
    ]), D = l(() => {
      const e = Math.ceil(n.value / 2);
      return {
        marginLeft: `${e}px`,
        marginRight: `${e}px`
      };
    }), E = W(), F = l(() => t.disabled ? !1 : E.tooltip ? u.value || o.value : !1), I = l(() => `0 0 0 ${n.value / 2}px var(--bg-button-text-primary-hover)`);
    q(r, (e) => {
      s.value = e;
    }, { immediate: !0 });
    function L(e) {
      if (t.overflow)
        switch (e) {
          case 3:
            s.value = t.min;
            break;
          case 4:
            s.value = t.max;
            break;
        }
      else
        switch (e) {
          case 3:
            r.value = t.min;
            break;
          case 4:
            r.value = t.max;
            break;
        }
    }
    function M(e, a) {
      d("dragging", e, a);
    }
    function R(e) {
      u.value = !0, d("drag-start", e);
    }
    function A(e) {
      u.value = !1, d("drag-end", e);
    }
    function N(e) {
      r.value = e;
    }
    return (e, a) => (G(), J(i(U), {
      "dot-attrs": {
        "aria-label": i(b).label,
        id: i(b).formItemId
      },
      "model-value": s.value,
      width: "auto",
      tooltip: "none",
      height: 4,
      data: e.data,
      "data-value": e.dataValue,
      "data-label": e.dataLabel,
      lazy: e.lazy,
      disabled: e.disabled,
      min: e.min,
      max: e.max,
      marks: e.marks,
      interval: e.interval,
      "dot-size": n.value,
      "hide-label": e.hideLabel,
      "rail-style": C.value,
      "step-style": z,
      "step-active-style": x,
      "process-style": e.processStyle,
      "label-style": k,
      process: e.process,
      silent: "",
      contained: !1,
      class: g($.value),
      style: y(D.value),
      onError: L,
      onDragStart: R,
      onDragging: M,
      onDragEnd: A,
      onChange: N
    }, {
      dot: c(({ value: p }) => [
        K(i(Y), {
          lazy: !1,
          show: F.value,
          "trigger-by-hover": !1,
          "auto-close": !1,
          placement: "top",
          arrow: ""
        }, {
          content: c(() => [
            P(e.$slots, "tooltip", { value: p })
          ]),
          default: c(() => [
            Q("div", {
              class: g(B.value),
              style: y(V.value),
              tabindex: "-1",
              role: "button",
              onMouseover: a[0] || (a[0] = (v) => o.value = !0),
              onFocus: a[1] || (a[1] = (v) => o.value = !0),
              onMouseout: a[2] || (a[2] = (v) => o.value = !1),
              onBlur: a[3] || (a[3] = (v) => o.value = !1)
            }, null, 38)
          ]),
          _: 2
        }, 1032, ["show"])
      ]),
      _: 3
    }, 8, ["dot-attrs", "model-value", "data", "data-value", "data-label", "lazy", "disabled", "min", "max", "marks", "interval", "dot-size", "hide-label", "rail-style", "process-style", "process", "class", "style"]));
  }
});
export {
  oe as default
};
//# sourceMappingURL=slider.js.map
